import * as React from 'react';

export const regNrRegex = /[A-Z]{3}[0-9]{2}[0-9A-Z]/ig;

export function isValidRegNr(val: string) {
  return regNrRegex.test(val);
}

interface RegNrBoxProps {
  initialValue?: string;
  regNrSelected: (regNr: string) => void;
  header: string;
  desc: string;
  getCarDetails: (regNr: string) => void;
  userSearched: boolean;
}

export function RegNrBox({
  initialValue, regNrSelected, header, desc, getCarDetails, userSearched}: RegNrBoxProps) {

  const [value, setValue] = React.useState(initialValue ?? '');

  React.useEffect(() => {
    const val = value.replace(' ', '');

    if (isValidRegNr(val)) {
      regNrSelected(val.toUpperCase());
    }

  }, [value]);

  return (
    <div className='inner-regnr-container'>
      <i className='fas fa-coins'></i>
      <h3 className='page-intro-header'>{header}</h3>
      <div className='reg-input'>
        <input
          className={`${userSearched ? 'locked' : ''}`}
          readOnly={userSearched}
          placeholder='ABC12X'
          type='text'
          value={value}
          onChange={e => setValue(e.target.value)}
          autoFocus />

        {initialValue !== '' &&
          <div className='find-car-details cta-btn primary'
            onClick={() => getCarDetails(initialValue ?? '')}>Hämta bil</div>}
      </div>
      <div className='element-description' dangerouslySetInnerHTML={{__html: desc as string}}></div>
    </div>
  );
}